import { render } from "./GhgInternshipProject.vue?vue&type=template&id=c0df4c8e&scoped=true"
const script = {}

import "./GhgInternshipProject.vue?vue&type=style&index=0&id=c0df4c8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0df4c8e"]])

export default __exports__